export const PAYMENT_PAGE_TYPE = {
  DIRECT: 'DIRECT',
  LIST: 'LIST',
  GROUPS: 'GROUPS',
};
